import React from 'react';
import PropTypes from 'prop-types';
import { DateRangePicker } from 'react-dates';

class DateRangeField extends React.Component {
  constructor(props) {
    super(props);
    this.state = { focused: false };
  }
  render() {
    const {
      onChange,
      fromValue,
      toValue,
      fieldName,
      className = '',
      labels = {}
    } = this.props;

    const defaultFromLabel = 'Start Date', defaultToLabel = 'End Date';
    return (
      <div className={className}>
        <DateRangePicker
          className={className}
          isOutsideRange={() => {return false}}
          startDate={fromValue}
          endDate={toValue}
          noBorder={true}
          regular={true}
          onDatesChange={({ startDate, endDate }) => {
            onChange(fieldName, startDate, endDate)
          }}
          focusedInput={this.state.focused}
          onFocusChange={focused => this.setState({ focused })}
          startDatePlaceholderText={labels[`${fieldName}_from`] || defaultFromLabel}
          endDatePlaceholderText={labels[`${fieldName}_to`] || defaultToLabel}
          style={{ fontSize: '12px' }}
          displayFormat={'D/M/YYYY'}
        />
        <i
          onClick={(e) => onChange(fieldName, null, null) }
          className="material-icons icon_close"
        >
          close
        </i>
      </div>
    );
  }
}

DateRangeField.defaultProps = {};

DateRangeField.propTypes = {};

export default DateRangeField;



// WEBPACK FOOTER //
// ./src/components/InputField/DateRangeField.jsx